module.exports = __webpack_public_path__ + "static/media/saveYes.76e0b8e6.png";